import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import MediaQuery from 'react-responsive';
import { Link } from 'react-router-dom';
import './purchase.css';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import Icon1 from '../../asset/Purchase/icon1.png';
import Icon2 from '../../asset/Purchase/icon2.png';
import Icon3 from '../../asset/Purchase/icon3.png';
import Icon4 from '../../asset/Purchase/icon4.png';
import Step1 from '../../asset/Purchase/step1.png';
import Step2 from '../../asset/Purchase/step2.png';
import Step3 from '../../asset/Purchase/step3.png';
import Step3Sp from '../../asset/Purchase/step3sp.png';
import Step4 from '../../asset/Purchase/step4.png';
import Chat from '../../asset/Purchase/chat.png';
import Mail from '../../asset/Purchase/mail.png';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Purchase = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>ご購入流れ | 株式会社TERRA</title>
      </Helmet>
      <div className="purchase" style={{ background: 'rgb(235, 244, 246)' }}>
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          ご購入流れ
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>ご購入流れ</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container p-0 p-lg-5" style={{ background: 'rgb(235,244,246)' }}>
          <MediaQuery query="(min-width: 960px)">
            <div className="row mb-5">
              <div className="col-3">
                <div className="circle">
                  <img src={Icon1} style={{ maxWidth: '100%' }} alt="商品を探す" />
                  <p>商品を探す</p>
                </div>
              </div>
              <div className="col-3">
                <div className="circle">
                  <img src={Icon2} style={{ maxWidth: '100%' }} alt="お客様情報の入力" />
                  <p>お客様情報の入力</p>
                </div>
              </div>
              <div className="col-3">
                <div className="circle">
                  <img src={Icon3} style={{ maxWidth: '100%' }} alt="お支払い方法の選択" />
                  <p>お支払い方法の選択</p>
                </div>
              </div>
              <div className="col-3">
                <div className="circle">
                  <img src={Icon4} style={{ maxWidth: '100%' }} alt="ご注文完了" />
                  <p>ご注文完了</p>
                </div>
              </div>
            </div>
            <div className="row my-3 p-3" style={{ background: 'white', height: '250px' }}>
              <div className="col-1">
                <div className="step_num">
                  STEP
                  <br />
                  1
                </div>
              </div>
              <div className="col-6">
                <p className="step_title">商品を探す</p>
                <p>商品ページのご希望商品を商品をお選び頂き、数量を選びカートに入れるボタンを押して下さい。</p>
              </div>
              <div className="col-5">
                <img className="step_img" src={Step1} style={{ maxWidth: '100%' }} alt="商品を探す" />
              </div>
            </div>
            <div className="row my-3 p-3" style={{ background: 'white', height: '250px' }}>
              <div className="col-1">
                <div className="step_num">
                  STEP
                  <br />
                  2
                </div>
              </div>
              <div className="col-6">
                <p className="step_title">お客様情報の入力</p>
                <p>
                  ログインまたは会員登録をお選びください。
                  <br />
                  定期便を新規お申し込みの方は、新規お申し込みボランより商品を選択し、
                  お客様情報を入力してください。
                </p>
              </div>
              <div className="col-5">
                <img className="step_img" src={Step2} style={{ maxWidth: '100%' }} alt="お客様情報の入力" />
              </div>
            </div>
            <div className="row my-3 p-3" style={{ background: 'white', height: '250px' }}>
              <div className="col-1">
                <div className="step_num">
                  STEP
                  <br />
                  3
                </div>
              </div>
              <div className="col-6">
                <p className="step_title">お支払い方法の選択</p>
                <p>
                  当サイトではクレジット決済、銀行振込、代引き支払いをご利用いただけます。
                  お客様のご都合のよろしい方法でご決済ください。
                </p>
              </div>
              <div className="col-5">
                <img className="step_img" src={Step3} style={{ maxWidth: '100%' }} alt="お支払い方法の選択" />
              </div>
            </div>
            <div className="row my-3 p-3" style={{ background: 'white', height: '250px' }}>
              <div className="col-1">
                <div className="step_num">
                  STEP
                  <br />
                  4
                </div>
              </div>
              <div className="col-6">
                <p className="step_title">ご注文完了</p>
                <p>
                  ご注文頂きました商品の検品・梱包を行い出荷いたします。
                </p>
              </div>
              <div className="col-5">
                <img className="step_img" src={Step4} style={{ maxWidth: '100%' }} alt="ご注文完了" />
              </div>
            </div>
          </MediaQuery>
          <MediaQuery query="(max-width: 959px)">
            <div className="d-block">
              <div className="step_sp bg_blue mt-5">
                <div className="step_item">
                  <img src={Icon1} style={{ maxHeight: '40px' }} alt="商品を探す" />
                  商品を探す
                </div>
              </div>
              <div className="triangle" />
              <div className="step_sp bg_blue">
                <div className="step_item">
                  <img src={Icon2} style={{ maxWidth: '100%' }} alt="商品を探す" />
                  お客様情報の入力
                </div>
              </div>
              <div className="triangle" />
              <div className="step_sp bg_blue">
                <div className="step_item">
                  <img src={Icon3} style={{ maxWidth: '100%' }} alt="商品を探す" />
                  お支払い方法の選択
                </div>
              </div>
              <div className="triangle" />
              <div className="step_sp bg_blue">
                <div className="step_item">
                  <img src={Icon4} style={{ maxWidth: '100%' }} alt="商品を探す" />
                  ご注文完了
                </div>
              </div>
            </div>
            <div className="step_desc_sp bg-white mt-5">
              <p className="step_num_sp">STEP 1</p>
              <div className="row p-3">
                <div className="col-6">
                  <p className="step_title_sp">商品を探す</p>
                  <p>商品ページのご希望商品を商品をお選び頂き、数量を選びカートに入れるボタンを押して下さい。</p>
                </div>
                <div className="col-6">
                  <img className="step_img_sp" src={Step1} style={{ maxWidth: '100%' }} alt="商品を探す" />
                </div>
              </div>
            </div>
            <div className="step_desc_sp bg-white">
              <p className="step_num_sp">STEP 2</p>
              <div className="row p-3">
                <div className="col-6">
                  <p className="step_title_sp">お客様情報の入力</p>
                  <p>
                    ログインまたは会員登録をお選びください。
                    <br />
                    定期便を新規お申し込みの方は、新規お申し込みボランより商品を選択し、
                    お客様情報を入力してください。
                  </p>
                </div>
                <div className="col-6">
                  <img className="step_img_sp" src={Step2} style={{ maxWidth: '100%' }} alt="お客様情報の入力" />
                </div>
              </div>
            </div>
            <div className="step_desc_sp bg-white">
              <p className="step_num_sp">STEP 3</p>
              <div className="row p-3">
                <div className="col-6">
                  <p className="step_title_sp">お支払い方法の選択</p>
                  <p>
                    当サイトではクレジット決済、銀行振込、代引き支払いをご利用いただけます。
                    お客様のご都合のよろしい方法でご決済ください。
                  </p>
                </div>
                <div className="col-6">
                  <img className="step_img_sp" src={Step3Sp} style={{ maxWidth: '100%' }} alt="お支払い方法の選択" />
                </div>
              </div>
            </div>
            <div className="step_desc_sp bg-white">
              <p className="step_num_sp">STEP 4</p>
              <div className="row p-3">
                <div className="col-6">
                  <p className="step_title_sp">ご注文完了</p>
                  <p>
                    ご注文頂きました商品の検品・梱包を行い出荷いたします。
                  </p>
                </div>
                <div className="col-6">
                  <img className="step_img_sp" src={Step4} style={{ maxWidth: '100%' }} alt="ご注文完了" />
                </div>
              </div>
            </div>
          </MediaQuery>
          <br />
          <h3 className="text-center text_blue m-3">お買い物に関するお困りごとはこちら</h3>
          <p className="text-center">お買い物に関するお困りごとやその他のお問い合わせはこちらから</p>
          <br />
          <div className="d-flex flex-wrap m-auto" style={{ justifyContent: 'space-around', maxWidth: '900px', fontSize: 'larger' }}>
            <Link
              to="/faq"
              className="btn_chat text_blue bg-white"
              style={{
                textDecoration: 'none',
                width: '350px',
                height: '5rem',
                borderRadius: '50px',
                padding: '1.5rem',
                textAlign: 'center',
                border: '1px solid rgb(34, 75, 113)',
                marginBottom: '1.5rem',
              }}
            >
              <img src={Chat} style={{ maxHeight: '40px', paddingRight: '30px' }} alt="よくある質問" />
              よくあるご質問
            </Link>
            <Link
              to="/contact"
              className="btn_contact text_blue bg-white"
              style={{
                textDecoration: 'none',
                width: '350px',
                height: '5rem',
                borderRadius: '50px',
                padding: '1.5rem',
                textAlign: 'center',
                border: '1px solid rgb(34, 75, 113)',
                marginBottom: '1.5rem',
              }}
            >
              <img src={Mail} style={{ maxHeight: '40px', paddingRight: '30px', maxWidth: '80px' }} alt="お問い合わせフォーム" />
              お問合わせフォーム
            </Link>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};

export default Purchase;
